import React from "react";
import StartWorkButton from "./Buttons/StartWorkButton";
import StopWorkButton from "./Buttons/StopWorkButton";
import StartBreakButton from "./Buttons/StartBreak";
import StopBreakButton from "./Buttons/StopBreakButton";
import EndWorkingDayButton from "./Buttons/EndWorkingDay";
import {clockTimingInterface, clockTrackingDataInterface} from "../../../API/request/clockTimingInterface";
import {ResponseSettings} from "../../../API/response/settingstimetracking";
import {IntlMessage, UniButton, UniSpinner} from "../../../../../@WUM/core/Elements";
import {SettingsInterface} from "../../../API/request/settingsworktimetrackingInterface";
import {useNavigate} from "react-router-dom";

interface ActionButtonBarProps {
    currentState: clockTrackingDataInterface;
    today: string;
    onStartWorkSuccess?: (data: clockTimingInterface) => void;
    onRefresh: () => void;
}

const ActionButtonBar = ({
                             currentState,
                             today,
                             onStartWorkSuccess,
                             onRefresh,
                         }: ActionButtonBarProps) => {
    const modus = currentState.Modus;

    const navigate = useNavigate();

    const handleStartWorkSuccess = (data: clockTimingInterface) => {
        onRefresh();
        onStartWorkSuccess?.(data);
    };

    const handleGeneric = () => {
        onRefresh();
    };

    const settings = ResponseSettings();

    if (!settings || typeof settings === "undefined" || typeof settings === "boolean") return <><UniSpinner /></>;

    if (Array.isArray(settings) && settings.length === 0) {
        return (
            <div className={"d-flex gap-2 align-items-center justify-content-center pt-3 gap-3"}>
                <div>
                    {IntlMessage({ locale: 'de', messageId: 'time.settings.missing', Store: '' })}
                </div>
                <UniButton
                    onClick={() => navigate("/settings/worktime")}
                >
                    Einstellungen
                </UniButton>
            </div>
        );
    }

    console.log(settings);

    const s = settings as SettingsInterface;

    // check if today is a working day
    const todayShort = new Intl.DateTimeFormat("de-DE", { weekday: "short" }).format(new Date());
    const isWorkingDay = Array.isArray(s.workingDays) && s.workingDays.includes(todayShort + '.');

    if (!isWorkingDay) {
        return (
            <div className="d-flex gap-2 align-items-center justify-content-center pt-3 gap-3">
                Heute ist kein Arbeitstag, Arbeitsaufnahme nicht möglich.
            </div>
        );
    }

    const timeToSeconds = (t?: string | null) => {
        if (!t) return null;
        const [hh = "0", mm = "0", ss = "0"] = t.split(":");
        return (+hh) * 3600 + (+mm) * 60 + (+ss);
    };

    const now = new Date();
    const nowSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
    const flexiStartSeconds = timeToSeconds(s.flexitimeStart);

    return (
        <>
            <div className={"d-flex gap-2 align-items-center justify-content-center pt-3 gap-3"}>
                {(modus === "Not Started") && (
                    <>
                        <div>
                            {(s.allowFlexitime && typeof flexiStartSeconds === "number" && nowSeconds < flexiStartSeconds) &&
                                <div className="d-flex gap-2 align-items-center justify-content-center pt-3 gap-3">
                                    Hinweis: Du befindest dich ausserhalb deiner Gleitzeit welche von {s.flexitimeStart.slice(0, 5)} Uhr bis {s.flexitimeEnd.slice(0, 5)} Uhr ist.
                                </div>
                            }
                            <div className="d-flex gap-2 align-items-center justify-content-center pt-3 gap-3">
                                <StartWorkButton onSuccess={handleStartWorkSuccess}/>
                            </div>
                        </div>
                    </>
                )}

                {(modus === "Day running") && (
                    <>
                        <StartWorkButton onSuccess={handleStartWorkSuccess} />
                        <EndWorkingDayButton onSuccess={handleGeneric} />
                    </>

                )}

                {modus === "Working" && (
                    <>
                        <StartBreakButton onSuccess={handleGeneric} />
                        {settings.allowWorkTimeInterruption && <><StopWorkButton onSuccess={handleGeneric} /></>}
                        <EndWorkingDayButton onSuccess={handleGeneric} />
                    </>
                )}

                {modus === "Pause" && (
                    <>
                        <StopBreakButton onSuccess={handleGeneric} />
                        {settings.allowWorkTimeInterruption && <><StopWorkButton onSuccess={handleGeneric} /></>}
                        <EndWorkingDayButton onSuccess={handleGeneric} />
                    </>
                )}

                {modus === "Ended" && (
                    <div>Arbeitstag beendet</div>
                )}
            </div>
        </>
    );
};

export default ActionButtonBar;
